import DropdownMenuEllipsis from "ds/components/DropdownMenu/Ellipsis";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";

type VCSIntegrationsOriginDropdownActionsProps = {
  onShowDetails: () => void;
  onEdit: () => void;
  onDelete: () => void;
  canManageVCSIntegrations: boolean;
};

const VCSIntegrationsOriginDropdownActions = ({
  onShowDetails,
  onEdit,
  onDelete,
  canManageVCSIntegrations,
}: VCSIntegrationsOriginDropdownActionsProps) => {
  return (
    <DropdownMenuEllipsis tooltip="Integration actions">
      <DropdownMenuItem onAction={onShowDetails}>See details</DropdownMenuItem>
      {canManageVCSIntegrations && (
        <>
          <DropdownMenuItem onAction={onEdit}>Edit</DropdownMenuItem>
          <DropdownMenuItem onAction={onDelete} danger>
            Delete
          </DropdownMenuItem>
        </>
      )}
    </DropdownMenuEllipsis>
  );
};

export default VCSIntegrationsOriginDropdownActions;
